import { toast } from "sonner";

// ============================================================
//  CONFIGURAZIONE WHATSAPP
//  Il numero e lo stato del canale vengono gestiti dall'area
//  amministrativa (/admin/whatsapp) tramite WhatsApp Cloud API.
//  I valori qui sotto sono solo il fallback iniziale.
// ============================================================
export const WHATSAPP_NUMBER = "393000000000";
export const WHATSAPP_ACTIVE = false;

// Messaggio precompilato che si apre nella chat WhatsApp
export const WHATSAPP_MESSAGE =
  "Buongiorno, vorrei ricevere maggiori informazioni sul servizio TytoCare di visite mediche assistite a domicilio.";

// Messaggio mostrato finché il canale WhatsApp non è attivo
export const COMING_SOON_MESSAGE = "Il servizio sarà presto disponibile nella tua zona";

const state = { active: WHATSAPP_ACTIVE, number: WHATSAPP_NUMBER };

// Carica numero/stato dal backend (impostati dall'admin)
export const loadWhatsAppConfig = async () => {
  try {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/whatsapp`);
    if (!res.ok) return;
    const data = await res.json();
    if (data.number) state.number = data.number;
    state.active = Boolean(data.active && data.number);
  } catch {
    // fallback ai valori statici
  }
};

export const getWhatsAppConfig = () => ({ ...state });

// Costruisce l'URL wa.me con messaggio precompilato
export const getWhatsAppUrl = (message = WHATSAPP_MESSAGE) =>
  `https://wa.me/${state.number}?text=${encodeURIComponent(message)}`;

// Apre WhatsApp in una nuova scheda, oppure mostra il messaggio "coming soon"
export const openWhatsApp = (message = WHATSAPP_MESSAGE) => {
  if (!state.active) {
    toast(COMING_SOON_MESSAGE);
    return;
  }
  window.open(getWhatsAppUrl(message), "_blank", "noopener,noreferrer");
};
